import { useEffect } from 'react';
import { logError } from '@/utils/logger/arms-config';
import { ieltsWeb } from '@/utils/env';


export const Redirect = () => {

  useEffect(() => {
    logError(`Invalid URL: ${window.location.href}`);
    (window as any).location.href = `${ieltsWeb}simulated_ielts/#/ `;
  }, []);

  return <></>;
};
